import React from 'react';
import { Col } from 'reactstrap';
import Rating from 'react-rating';

const RatingInput = (props) => {
    let maxLength = null;
    let minLength = null;

    if (props.validate) {
        maxLength = props.validate.max;
        minLength = props.validate.min;
    }

    return (
        <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className={`d-flex mb-4 ${props.placeholder || props.questionText ? ' form-floating' : ''}`}
        >
            <Rating
                id={props?.answerInternalIdentifier}
                className="my-auto"
                start={0}
                readonly={props.disable}
                step={1}
                onChange={(e) => {
                    if (props?.onChange) {
                        const questionsData = props?.onChange(e + '');
                        props?.handleSave && props.handleSave('', questionsData);
                    }
                    props?.changed(e);
                }}
                stop={10}
                initialRating={+props.value}
                fullSymbol={[
                    'ri-star-s-fill text-opacity-75 fs-24 text-danger',
                    'ri-star-s-fill text-opacity-75 fs-24 text-danger',
                    'ri-star-s-fill text-opacity-75 fs-24 text-danger',
                    'ri-star-s-fill text-opacity-75 fs-24 text-danger',
                    'ri-star-s-fill text-opacity-75 fs-24 text-warning',
                    'ri-star-s-fill text-opacity-75 fs-24 text-warning',
                    'ri-star-s-fill text-opacity-75 fs-24 text-warning',
                    'ri-star-s-fill text-opacity-75 fs-24 text-success',
                    'ri-star-s-fill text-opacity-75 fs-24 text-success',
                    'ri-star-s-fill text-opacity-75 fs-24 text-success'
                ]}
                emptySymbol={<i className="ri-star-s-line fs-24 text-secondary text-opacity-50"></i>}
            />
        </Col>
    );
};

export default RatingInput;
